import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup } from '@angular/forms';
import { TimeInterval } from 'src/app/shop/entities/timeInterval';
import { TimeSlot } from 'src/app/shop/entities/timeSlot';
import { DualListComponent } from '../dual-list/dual-list.component';
import { DeliveryTimeService } from '../services/delivery-times.service';

@Component({
  selector: 'app-edit-delivery',
  templateUrl: './edit-delivery.component.html',
  styleUrls: ['./edit-delivery.component.scss']
})
export class EditDeliveryComponent implements OnInit {
  currentDay: number;
  deliveryFee: string;
  errorOnDeliverySave: boolean = false;
  successfullySavedDelivery: boolean = false;
  savingDelivery: boolean;
  deliveryLeadTime: string;
  errorOnLeadTimeSave: boolean = false;
  successfullySavedLeadTime: boolean = false;
  savingLeadTime: boolean;

  constructor(private formBuilder: FormBuilder, private deliveryTimesService: DeliveryTimeService) { }

  saving: boolean = false;

  deliveryTimes: Array<TimeSlot> = new Array<TimeSlot>();

  key: string = 'id';

  successfullySaved: boolean = false;
  errorOnSave: boolean = false;

  filter = false;
  keepSorted = true;
  sourceLeft = true;
  format: any = DualListComponent.DEFAULT_FORMAT;
  confirmed: Array<TimeSlot> = new Array<TimeSlot>();
  disabled = false;
  display: string = 'time';
  activeList: Array<TimeSlot> = new Array<TimeSlot>();
  dateForm: FormGroup;
  currentDateString: string;
  showShopClosedError: boolean = false;

  ngOnInit(): void {

    this.dateForm = this.formBuilder.group({
      date: ['']
    })

    this.deliveryTimesService.getDeliveryCost().subscribe(x => {
      this.deliveryFee = x;
    })

    
    this.deliveryTimesService.getLeadTime().subscribe(x => {
      this.deliveryLeadTime = x;
    })


    this.dateForm.get("date").valueChanges.subscribe(x => {
      if (!!this.dateForm.get("date").value) {
        this.showShopClosedError = false;
        this.confirmed = new Array<TimeSlot>();
        var date = new Date(this.dateForm.get("date").value);
        const yy = new Date(date).getFullYear();
        const mm = new Date(date).getMonth() + 1;
        const dd = new Date(date).getDate();

        this.currentDateString = `${dd}-${mm}-${yy}`
        this.deliveryTimesService.getEditableDeliveryTimes(true, date.getDay()).subscribe(x => {
          this.deliveryTimes = x;
          var allDisabledDateSlots = this.deliveryTimes.map(x => x.disabledDateSlots);
          var i = 0;
          allDisabledDateSlots.forEach(x => {
            var matchingDates = x.filter(x => new Date(x.disableDateTime).getDate() == date.getDate() && new Date(x.disableDateTime).getMonth() == date.getMonth() && new Date(x.disableDateTime).getUTCFullYear() == date.getUTCFullYear());
            if (!!matchingDates && matchingDates.length > 0)
            {
              this.confirmed = this.confirmed.concat(this.deliveryTimes[i]);
            }
            i++;
          })
          this.doReset();
        },
        (error) => {
          if (error.status == '513')
          {
            this.showShopClosedError = true;
          }
        })

      }
    });

    this.dateForm.get('date').setValue(new Date());
  }

  doReset() {
    this.activeList = this.deliveryTimes.filter(x => !this.confirmed.includes(x));
    this.useDeliveryTimes();
  }

  private useDeliveryTimes() {
    this.key = 'id';
    this.display = 'time';
    this.keepSorted = true;
  }

  swapDirection() {
    this.sourceLeft = !this.sourceLeft;
    this.format.direction = this.sourceLeft ? DualListComponent.LTR : DualListComponent.RTL;
  }

  doDisable() {
    this.disabled = !this.disabled;
  }

  filterBtn() {
    return (this.filter ? 'Hide Filter' : 'Show Filter');
  }

  disableBtn() {
    return (this.disabled ? 'Enable' : 'Disabled');
  }

  public save() {
    this.saving = true;
    this.successfullySaved = false;
    this.errorOnSave = false;

    this.deliveryTimesService.updateDeliveryTimes(this.confirmed, this.currentDateString, true).subscribe(x => {
      this.saving = false;
      this.errorOnSave = false;
      this.successfullySaved = true;
    },
     (error) => {
      this.saving = false;
      this.successfullySaved = false;
      this.errorOnSave = true;
     })
  }

  public saveDeliveryFee() {
    this.savingDelivery = true;
    this.successfullySavedDelivery = false;
    this.errorOnDeliverySave = false;

    this.deliveryTimesService.setDeliveryCost(this.deliveryFee.toString()).subscribe(x => {
      this.savingDelivery = false;
      this.errorOnDeliverySave = false;
      this.successfullySavedDelivery = true;
    },
     (error) => {
      this.savingDelivery = false;
      this.successfullySavedDelivery = false;
      this.errorOnDeliverySave = true;
     })
  }

  public saveLeadTime() {
    this.savingLeadTime = true;
    this.successfullySavedLeadTime = false;
    this.errorOnLeadTimeSave = false;

    this.deliveryTimesService.setDeliveryLeadTime(this.deliveryLeadTime.toString()).subscribe(x => {
      this.savingLeadTime = false;
      this.errorOnLeadTimeSave = false;
      this.successfullySavedLeadTime = true;
    },
     (error) => {
      this.savingLeadTime = false;
      this.successfullySavedLeadTime = false;
      this.errorOnLeadTimeSave = true;
     })
  }

  setActiveList(event: any) {
    this.successfullySaved = false;
    this.errorOnSave = false;

    this.activeList = new Array<TimeSlot>();
    var eventIds = event.map(x => x._id);

    if (!!eventIds && eventIds.length > 0) {
      for (let i = 0; i < eventIds.length; i++) {
        var timeInterval = this.deliveryTimes.find(x => x.id == eventIds[i]);
        if (!!timeInterval)
        {
          this.activeList.push(timeInterval);
        }
      }
    }
  }

  changeDay(event: any)
  {
    this.successfullySaved = false;
    this.errorOnSave = false;
    this.deliveryTimesService.getEditableDeliveryTimes(true, event.value).subscribe(x => {
      this.deliveryTimes = x;
      this.doReset();
    })
  }

}
